// src/App.jsx
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import MainLayout from './components/MainLayout';

// Pages & Components
import Login from './Auth/Login';
import Register from './Auth/Register';
import Profile from './Profile/Profile';
import ChangePassword from './Profile/ChangePassword';

// Admin
import MyDemandes from './Pages/Admin/MyDemandes';
import Notifications from './Pages/Admin/Notifications';
import UsersList from './Pages/Admin/UsersList';
import Categories from './Pages/Admin/Categories';
import Materiels from './Pages/Admin/Materiels';
import ToutesDemandes from './Pages/Admin/ToutesDemandes';

// Demandes utilisateur
import CreateDemande from './Pages/demandes/CreateDemande';
import MesDemandes from './Pages/demandes/MesDemandes';
import HistoriqueDemande from './Pages/demandes/HistoriqueDemande';
import TimelineDemande from './Pages/demandes/TimelineDemande';
import TousHistoriques from './Pages/historique/TousHistoriques';

// Validateur
import ValidationDashboard from './Pages/validateur/ValidationDashboard';
import ValiderDemande from './Pages/validateur/ValiderDemande';

// Magasinier
import MagasinDashboard from './Pages/magasinier/MagasinDashboard';
import PreparateurDemande from './Pages/magasinier/PreparateurDemande';
import ValidatedDemandes from './Pages/magasinier/ValidatedDemandes';
import ReadyDemandes from './Pages/magasinier/ReadyDemandes';
import Recuperationlist from './Pages/magasinier/Recuperationlist';
import RecupererDemande from './Pages/magasinier/RecuperationDemandes';
import SuiviRecuperation from './Pages/magasinier/SuiviRecuperation';

// Autres
import RapportsDashboard from './Pages/Rapports/RapportsDashboard';
import NotificationsPage from './Pages/NotificationsPage';

// Congés
import NouvelleDemande from './Conges/NouvelleDemande';
import MesConges from './Conges/MesConges';
import DetailConge from './Conges/DetailConge';
import AdminConges from './Conges/AdminConges';
import TraiterConge from './Conges/TraiterConge';
import ConfirmerConge from './Conges/ConfirmerConge';
import ValidateurConges from './Conges/ValidateurConges';
import ChefDashboard from './Conges/ChefDashboard';

// VÉHICULES
import VehiculeList from './Vehicules/VehiculeList';
import VehiculeDetails from './Vehicules/VehiculeDetails';
import VehiculeForm from './Vehicules/VehiculeForm';
import DemandeListVehicule from './Vehicules/DemandeListVehicule';
import DemandeDetailsVehicule from './Vehicules/DemandeDetailsVehicule';
import DemandeFormVehicule from './Vehicules/DemandeFormVehicule';
import ValidationFormVehicule from './Vehicules/ValidationFormVehicule';
import ReparationDetailsVehicule from './Vehicules/ReparationDetailsVehicule';
import ReparationFormVehicule from './Vehicules/ReparationFormVehicule';
import PieceFormVehicule from './Vehicules/PieceFormVehicule';
import PieceListVehicule from './Vehicules/PieceListVehicule';
import ListeReparationsVehicule from './Vehicules/ListeReparationsVehicule';

// ÉVÉNEMENTS
import BeneficiairesPages from './Evenement/Admin/BeneficiairesPage';
import PacksEnterrementPage from './Evenement/Admin/PacksEnterrementPage';
import EvenementsPage from './Evenement/Admin/EvenementsPage';
import HistoriquesPage from './Evenement/Admin/HistoriquesPage';
import CreerEvenement from './Evenement/Client/CreerEvenement';
import MyEvenements from './Evenement/Client/MyEvenements';
import ValidationEvenements from './Evenement/Validateur/ValidationEvenements';
import LivraisonsMagasinier from './Evenement/Magasiner/LivraisonsMagasinier';
import GestionRetours from './Evenement/Magasiner/GestionRetours';
import GestionLivraisonMateriels from './Evenement/Magasiner/GestionLivraisonMateriels';
import Accuiel from './Accuiel/Accuiel';
import AuthTimeout from './components/AuthTimeout';
import Aide from './Pages/Aide';

// Layout pour les pages avec sidebar
function LayoutWithSidebar() {
  const location = useLocation();
  const noSidebarPaths = ['/login', '/register'];
  
  if (noSidebarPaths.includes(location.pathname)) {
    return (
      <div className="min-h-screen ">
        <Outlet />
      </div>
    );
  }
  
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

// Route protégée
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

// Route Admin uniquement
function AdminRoute({ children }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

// Route spécifique pour certains rôles
function RoleRoute({ children, allowedRoles }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

// Route publique (redirige si déjà connecté)
function PublicRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? <Navigate to="/" replace /> : children;
}

export default function App() {  
  return (
    <>
    
    <Routes>
       <Route path="/Aide" element={
            <Aide />
        } />
      {/* Public Routes */}
      <Route path="/login" element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      } />
      
      <Route path="/register" element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      } />

      {/* Layout avec Sidebar */}
      <Route element={<LayoutWithSidebar />}>
        {/* Accueil */}
        <Route path="/" element={
          <ProtectedRoute>
            <Accuiel />
          </ProtectedRoute>
        } />
        
        {/* Statistiques */}
        <Route path="/Statistiques" element={
          <ProtectedRoute>
            <RapportsDashboard />
          </ProtectedRoute>
        } />

        {/* Profil */}
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        
        <Route path="/Demandes-recuperer" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <ReadyDemandes />
          </RoleRoute>
        } />
        
        <Route path="/validees-preparer" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <ValidatedDemandes />
          </RoleRoute>
        } />
        
        <Route path="/change-password" element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        } />

        {/* ===================== VÉHICULES ===================== */}
        <Route path="/vehicules" element={
          <ProtectedRoute>
            <VehiculeList />
          </ProtectedRoute>
        } />
        
        <Route path="/vehicules/nouveau" element={
          <RoleRoute allowedRoles={['admin', 'chef_equipe']}>
            <VehiculeForm />
          </RoleRoute>
        } />
        
        <Route path="/vehicules/:id" element={
          <ProtectedRoute>
            <VehiculeDetails />
          </ProtectedRoute>
        } />
        
        <Route path="/vehicules/:id/edit" element={
          <RoleRoute allowedRoles={['admin', 'chef_equipe']}>
            <VehiculeForm />
          </RoleRoute>
        } />

        {/* ===================== DEMANDES RÉPARATION ===================== */}
        <Route path="/demandes-reparation" element={
          <ProtectedRoute>
            <DemandeListVehicule />
          </ProtectedRoute>
        } />
        
        <Route path="/demandes-reparation/nouvelle" element={
          <ProtectedRoute allowedRoles={['mecanicien', 'validateur']}>
            <DemandeFormVehicule />
          </ProtectedRoute>
        } />
        
        <Route path="/demandes-reparation/:id" element={
          <ProtectedRoute allowedRoles={['client', 'mecanicien']}>
            <DemandeDetailsVehicule />
          </ProtectedRoute>
        } />
        
        <Route path="/demandes-reparation/:id/edit" element={
          <RoleRoute allowedRoles={['validateur', 'chef_equipe']}>
            <DemandeFormVehicule />
          </RoleRoute>
        } />

        {/* ===================== VALIDATIONS ===================== */}
        <Route path="/validations/nouvelle" element={
          <RoleRoute allowedRoles={['validateur', 'chef_equipe']}>
            <ValidationFormVehicule />
          </RoleRoute>
        } />

        {/* ===================== RÉPARATIONS ===================== */}
        <Route path="/reparations/nouvelle" element={
          <RoleRoute allowedRoles={['mecanicien']}>
            <ReparationFormVehicule />
          </RoleRoute>
        } />
        
        <Route path="/reparations/:id" element={
          <ProtectedRoute>
            <ReparationDetailsVehicule />
          </ProtectedRoute>
        } />
        
        <Route path="/reparations" element={
          <RoleRoute allowedRoles={['mecanicien', 'magasinier', 'validateur', 'chef_equipe']}>
            <ListeReparationsVehicule />
          </RoleRoute>
        } />

        {/* ===================== PIÈCES ===================== */}
        <Route path="/pieces/nouvelle" element={
          <RoleRoute allowedRoles={['mecanicien', 'magasinier']}>
            <PieceFormVehicule />
          </RoleRoute>
        } />
        
        <Route path="/pieces" element={
          <RoleRoute allowedRoles={['mecanicien', 'magasinier']}>
            <PieceListVehicule />
          </RoleRoute>
        } />

        {/* ===================== PAGES EXISTANTES ===================== */}
        {/* Demandes utilisateur */}
        <Route path="/demandes/nouvelle" element={
          <ProtectedRoute>
            <CreateDemande />
          </ProtectedRoute>
        } />
        
        <Route path="/mes-demandes" element={
          <ProtectedRoute>
            <MesDemandes />
          </ProtectedRoute>
        } />
       
        <Route path="/demande-timeline/:demandeId" element={
          <ProtectedRoute>
            <TimelineDemande />
          </ProtectedRoute>
        } />
        
        <Route path="/historiques" element={
          <ProtectedRoute>
            <TousHistoriques />
          </ProtectedRoute>
        } />

        {/* Validateur */}
        <Route path="/validateur" element={
          <RoleRoute allowedRoles={['validateur']}>
            <ValidationDashboard />
          </RoleRoute>
        } />
        
        <Route path="/validateur/demandes/:id" element={
          <RoleRoute allowedRoles={['validateur']}>
            <ValiderDemande />
          </RoleRoute>
        } />
        
        <Route path="/demandes/historique/:id" element={
          <ProtectedRoute>
            <HistoriqueDemande />
          </ProtectedRoute>
        } />

        {/* Magasinier */}
        <Route path="/magasin" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <MagasinDashboard />
          </RoleRoute>
        } />
        
        <Route path="/magasin/preparer/:id" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <PreparateurDemande />
          </RoleRoute>
        } />
        
        <Route path="/magasin/recuperer" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <Recuperationlist />
          </RoleRoute>
        } />
        
        <Route path="/magasin/recuperer/:id" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <RecupererDemande />
          </RoleRoute>
        } />
        
        <Route path="/magasin/suivi/:id" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <SuiviRecuperation />
          </RoleRoute>
        } />
        
        {/* Rapports & Notifications */}
        <Route path="/rapports" element={
          <ProtectedRoute>
            <RapportsDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/notifications" element={
          <ProtectedRoute>
            <NotificationsPage />
          </ProtectedRoute>
        } />

        {/* Admin */}
        <Route path="/admin/my-demandes" element={
          <AdminRoute>
            <MyDemandes />
          </AdminRoute>
        } />
        
        <Route path="/admin/notifications" element={
          <AdminRoute>
            <Notifications />
          </AdminRoute>
        } />
        
        <Route path="/admin/users" element={
          <AdminRoute>
            <UsersList />
          </AdminRoute>
        } />
        
        <Route path="/admin/categories" element={
          <AdminRoute>
            <Categories />
          </AdminRoute>
        } />
        
        <Route path="/admin/materiels" element={
          <AdminRoute>
            <Materiels />
          </AdminRoute>
        } />
        
        <Route path="/admin/demandes" element={
          <AdminRoute>
            <ToutesDemandes />
          </AdminRoute>
        } />

        {/* Congés */}
        <Route path="/conges/nouveau" element={
          <ProtectedRoute>
            <NouvelleDemande />
          </ProtectedRoute>
        } />
        
        <Route path="/mes-conges" element={
          <ProtectedRoute>
            <MesConges />
          </ProtectedRoute>
        } />
        
        <Route path="/conge/:id" element={
          <ProtectedRoute>
            <DetailConge />
          </ProtectedRoute>
        } />

        {/* Validateur - Congés */}
        <Route path="/validateur/conges" element={
          <RoleRoute allowedRoles={['validateur']}>
            <ValidateurConges />
          </RoleRoute>
        } />
        
        <Route path="/validateur/conge/:id/traiter" element={
          <RoleRoute allowedRoles={['validateur']}>
            <TraiterConge />
          </RoleRoute>
        } />

        {/* Chef d'équipe - Congés */}
        <Route path="/chef/conges" element={
          <RoleRoute allowedRoles={['chef_equipe']}>
            <ChefDashboard />
          </RoleRoute>
        } />
        
        <Route path="/chef/conge/:id/confirmer" element={
          <RoleRoute allowedRoles={['chef_equipe']}>
            <ConfirmerConge />
          </RoleRoute>
        } />

        {/* Admin - Congés */}
        <Route path="/admin/conges" element={
          <AdminRoute>
            <AdminConges />
          </AdminRoute>
        } />
        
        <Route path="/admin/beneficiaires" element={
          <AdminRoute>
            <BeneficiairesPages />
          </AdminRoute>
        } />
        
        <Route path="/admin/packs-enterrement" element={
          <AdminRoute>
            <PacksEnterrementPage />
          </AdminRoute>
        } />
        
        <Route path="/admin/evenements" element={
          <AdminRoute>
            <EvenementsPage />
          </AdminRoute>
        } />
        
        <Route path="/admin/evenements/historique" element={
          <AdminRoute>
            <HistoriquesPage />
          </AdminRoute>
        } />
        
        <Route path="/client/evenements/nouveau" element={
          <RoleRoute allowedRoles={['client']}>
            <CreerEvenement />
          </RoleRoute>
        } />
        
        <Route path="/client/mes-evenements" element={
          <RoleRoute allowedRoles={['client']}>
            <MyEvenements />
          </RoleRoute>
        } />
        
        <Route path="/validateur/validation-evenements" element={
          <RoleRoute allowedRoles={['validateur']}>
            <ValidationEvenements />
          </RoleRoute>
        } />
        
        <Route path="/magasinier/livraisons" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <LivraisonsMagasinier />
          </RoleRoute>
        } />
        
        <Route path="/magasinier/livraison-materiels/:livraisonId" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <GestionLivraisonMateriels />
          </RoleRoute>
        } />
        
        <Route path="/magasinier/retours/:livraisonId" element={
          <RoleRoute allowedRoles={['magasinier']}>
            <GestionRetours />
          </RoleRoute>
        } />

        {/* Route 404 */}
        <Route path="*" element={
          <ProtectedRoute>
            <div className="flex items-center justify-center min-h-[60vh]">
              <div className="text-center p-8 bg-white rounded-xl shadow-lg max-w-md">
                <h1 className="text-3xl font-bold text-red-500 mb-4">404</h1>
                <p className="text-gray-600 mb-6">La page que vous recherchez n'existe pas.</p>
                <a href="/" className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors inline-block">
                  Retour à l'accueil
                </a>
              </div>
            </div>
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
    </>
  );
}